import React, { useState, useEffect } from "react";
import { Paper, Grid, makeStyles } from "@material-ui/core";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { format, subDays } from "date-fns";

import FilterBar from "./FilterBar";
import KPICards from "./KPICards";
import Charts from "./Charts";
import "./dashboard.css"; // Force spacing styles

const useStyles = makeStyles((theme) => ({
    mainPaper: {
        flex: 1,
        padding: theme.spacing(2),
        overflowY: "scroll",
        ...theme.scrollbarStyles,
    },
}));

const DashboardPerformance = () => {
    const classes = useStyles();
    const [loading, setLoading] = useState(false);

    // Initial Filters
    const [filters, setFilters] = useState({
        dateFrom: format(subDays(new Date(), 7), "yyyy-MM-dd"), // Last 7 days by default
        dateTo: format(new Date(), "yyyy-MM-dd"),
        queueIds: "", // Single value for now, or array logic in FilterBar
        userIds: "",
        connectionId: ""
    });

    // Data State
    const [data, setData] = useState({
        kpi: {
            total: 0, closed: 0, open: 0, pending: 0,
            avgWaitTime: "00h:00m", avgServiceTime: "00h:00m"
        },
        charts: {
            ticketsByQueue: [],
            ticketsByAgent: [],
            ticketsByChannel: []
        }
    });

    const fetchData = async () => {
        setLoading(true);
        try {
            console.log("Fetching dashboard data with filters:", filters);
            const { data: result } = await api.get("/dashboard/performance", {
                params: filters
            });
            console.log("Dashboard data received:", result);
            setData((prevState) => ({ ...prevState, ...result }));
        } catch (err) {
            console.error("Error fetching dashboard data:", err);
            toastError(err);
        }
        setLoading(false);
    };

    // Load on mount and when filters change
    useEffect(() => {
        fetchData();
    }, [filters]); // Auto-refresh when filters change

    const handleReload = () => {
        fetchData();
    };

    return (
        <MainContainer>
            <MainHeader>
                <Title>Performance Dashboard</Title>
            </MainHeader>

            <Paper className={classes.mainPaper} variant="outlined">
                <Grid container spacing={3}>
                    {/* Filters */}
                    <Grid item xs={12}>
                        <FilterBar
                            filters={filters}
                            onFilterChange={setFilters}
                            onReload={handleReload}
                        />
                    </Grid>

                    {/* KPIs */}
                    <Grid item xs={12}>
                        <KPICards kpi={data.kpi} />
                    </Grid>

                    {/* Charts */}
                    <Grid item xs={12}>
                        <Charts charts={data.charts} />
                    </Grid>

                    {/* Spacer to prevent bottom cutoff */}
                    <Grid item xs={12} style={{ height: '80px' }}>
                        {/* Empty spacer */}
                    </Grid>
                </Grid>
            </Paper>
        </MainContainer>
    );
};

export default DashboardPerformance;
